import until from "./until.js";
import {ajax, getRequestUrl, formatData, uploadImg, uploadFile} from "./request";
import router from "@/router"; // 引入router
import vue from "vue";
import jHttp from "./j-http.js";
import invite from "./https/Invite.js";
import users from "./https/users.js";
import roomColumn from "./https/roomColumn.js";
import roomCrystal from "./https/roomCrystal.js";
import room from "./https/room.js";
import Activity from "./https/Activity.js";
import setting from "./https/setting.js";
import admin from "./https/admin.js";
import message from "./https/message.js";
import sengCoins from "./https/sengCoins.js";
import agent from "./https/agent.js";
import role from "./https/role.js";
import power from "./https/power.js";
import ad from "./https/ad.js";
import shop from "./https/shop.js";
import family from "./https/family.js";
import gift from "./https/gift.js";
import group from "./https/group";
import approval from "./https/approval";
import data from "./https/data";
import activityDeploy from "./https/activityDeploy";
import bd from "./https/bd";
import templateAct from './https/templateAct'
import countryAdmin from "./https/countryAdmin";
import communityApi from "./https/communityApi";
import musicLibs from "./https/musicLibs";
import tribeManagement from "./https/tribeManagement.js";
import roomBot from "./https/roomBot";

vue.config.productionTip = false;

export default {
  // 登录
  login(data) {
    return ajax("post", getRequestUrl("/admin/login"), data);
  },

  // 选择运营区域
  operateAreaList(data) {
    return ajax("post", getRequestUrl("/api/Admin/operateAreaList"), data);
  },

  // 退出登录
  loginOut() {
    return ajax("post", getRequestUrl("/admin/logout"));
  },

  // 右侧账号头像-弹窗-账号信息
  uidInfo() {
    return ajax("post", getRequestUrl("/api/CommonHelper/uidInfo"));
  },

  // 导出表格
  exportData(arr) {
    let url = baseUrl + "/api/Service/servicekProblemListExport?" + arr.join("&");
    window.open(url, "_blank");
  },

  // 导出excel
  exportExtData(arr, reqUrl, extData = {}) {
    console.log(extData);
    if (!extData.listData && extData.listData !== undefined) {
      vue.prototype.$Message.warning(
        vue.prototype.$selfGlobal.$globalI18n.t("js.httpJs.exportNull")
      );
      return;
    }
    let url = getRequestUrl(reqUrl) + "&" + arr.join("&");
    window.open(url, "_blank");
  },

  // 上传图片
  upload(data, limitSize = null) {
    data.append('type','image')
    const file = {target:{files:[data.get('image')]}}
    if (!until.upImgSize(file, limitSize ? limitSize:1)){
      vue.prototype.$Message.warning('图片上传不能超过1M');
      return;
    }
    return uploadImg(getRequestUrl("/upload/file"), data);
  },

  // 上传视频
  uploadVideo(data, limitSize = null) {
    data.append('type','video')
    const file = {target:{files:[data.get('image')]}}
    if (!until.upImgSize(file, limitSize?limitSize:8)){
      vue.prototype.$Message.warning('视频上传不能超过8M');
      return;
    }
    return uploadImg(getRequestUrl("/upload/file"), data);
  },

  // 上传svga
  uploadSvga(data, limitSize = null) {
    data.append('type','svga')
    const file = {target:{files:[data.get('image')]}}
    if (!until.upImgSize(file, limitSize?limitSize:5)){
      vue.prototype.$Message.warning('SVGA上传不能超过5M');
      return;
    }
    return uploadImg(getRequestUrl("/upload/file"), data);
  },

  uploadExec(data) {
    data.append('type','excel')
    return uploadImg(getRequestUrl("/upload/file"), data);
  },
  uploadId(data) {
    return uploadFile(getRequestUrl("/msg/private/uploadId"), data);
  },

  // 管理员--超级管理员
  findSupermanList(data, method) {
    return ajax(
      "post",
      getRequestUrl("/api/Administrator/findSupermanList"),
      data,
      {
        method
      }
    ).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 管理员--国家管理员
  findCountryAdminList(data, method) {
    return ajax(
      "post",
      getRequestUrl("/api/Administrator/findCountryAdminList"),
      data,
      {
        method
      }
    ).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 敏感词保存
  saveSensitiveWords(data, method) {
    return ajax(
      "post",
      getRequestUrl("/api/SensitiveWords/saveSensitiveWords"),
      data,
      {
        method
      }
    ).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 操作日志
  historyLogList(data, method) {
    return ajax("post", getRequestUrl("/api/HistoryLog/historyLogList"), data, {
      method
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 国家管理 -- 列表
  findCountryListByPage(data, method) {
    return ajax(
      "post",
      getRequestUrl("/region/country/listByPage"),
      data,
      {
        method
      }
    ).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 国家管理 -- 新增/更新
  saveCountry(data, method) {
    return ajax("post", getRequestUrl("/region/country/save"), data, {
      method
    });
  },

  // 国家详情 -- 新增/更新
  getCountry(data, method) {
    return ajax("post", getRequestUrl("/api/Country/countryInfo"), data, {
      method
    });
  },

  // 热门国家保存
  hotCountrySave(data, method) {
    return ajax("post", getRequestUrl("/api/Country/hotCountrySave"), data, {
      method
    });
  },

  // 运营区域列表接口
  findOperationListByPage(data, method) {
    return ajax("post", getRequestUrl("/api/Country/operatingArea"), data, {
      method
    });
  },

  // 保存运营区域
  saveOperationListByPage(data, method) {
    return ajax("post", getRequestUrl("/api/Country/operatingAreaSave"), data, {
      method
    });
  },

  // 修改爱好
  updateLoveAPI(data, method) {
    return ajax("post", getRequestUrl("/api/Member/saveLove"), data, {
      method
    });
  },

  // 修改标签
  updateTipAPI(data, method) {
    return ajax("post", getRequestUrl("/api/Member/saveTip"), data, {
      method
    });
  },

  // 标签选择列表
  tipListAPI(data, method) {
    return ajax("post", getRequestUrl("/api/Member/tipList"), data, {
      method
    });
  },

  // 获取国家分区
  findpartitionnListByPage(data, method) {
    return ajax("post", getRequestUrl("/api/Country/countryRegionList"), data, {
      method
    });
  },

  // 更多设备
  findmemberMoreIpByPage(data, method) {
    return ajax("post", getRequestUrl("/user/moreDevice"), data, {
      method
    });
  },

  // 区域下拉选择列表
  findregionSelectListByPage(data, method) {
    return ajax("post", getRequestUrl("/region/regionSelectList"), data, {
      method
    });
  },

  // 编辑国家分区
  editpartitionnListByPage(data, method) {
    return ajax("post", getRequestUrl("/api/Country/countryRegionAdd"), data, {
      method
    });
  },

  // 保存运营区域
  saveOperatingAreaByPage(data, method) {
    return ajax("post", getRequestUrl("/api/Country/operatingAreaSave"), data, {
      method
    });
  },

  // 省份名单列表
  getProvinceList(data, method) {
    return ajax("post", getRequestUrl("/region/province/listByPage"), data, {
      method
    });
  },

  // 保存省份信息
  provinceSave(data, method) {
    return ajax("post", getRequestUrl("/region/province/save"), data, {
      method
    });
  },

  // 删除省份信息
  provinceDelete(data, method) {
    return ajax("post", getRequestUrl("/region/province/deletel"), data, {
      method
    });
  },

  // 删除运营区域
  delOperatingAreaByPage(data, method) {
    return ajax("post", getRequestUrl("/api/Country/operatingAreaDelete"), data, {
      method
    });
  },

  // 金币、道具、卡券、礼物发放列表
  getSendCoinsList(data, method) {
    return ajax("post", getRequestUrl("/api/SendCoins/uidIssueList"), data, {
      method
    });
  },

  // 房间置顶
  setRoomTop(data, method) {
    return ajax("post", getRequestUrl("/api/Room/stickRoom"), data, {
      method
    });
  },

  // 取消房间置顶
  cancelRoomTop(data, method) {
    return ajax("post", getRequestUrl("/api/Room/cancelStickRoom"), data, {
      method
    });
  },

  // 封禁详情
  getbanAccountList(data, method) {
    return ajax("post", getRequestUrl("/api/Member/banAccountList"), data, {
      method
    });
  },

  // 冻结详情
  getfreezeRechargeList(data, method) {
    return ajax("post", getRequestUrl("/ban/freezeMember/list"), data, {
      method
    });
  },

  // 30天退款明细
  refundDetailsListAPI(data, method) {
    return ajax("post", getRequestUrl("/user/recharge/refundList"), data, {
      method
    });
  },

  // 添加运营区域负责人
  addOperatingAreaManByPage(data, method) {
    return ajax("post", getRequestUrl("/api/Country/areaPrincipalAdd"), data, {
      method
    });
  },

  // 违规用户管理 -- 违规用户列表
  findMemberViolationByPage(data, method) {
    return ajax(
      "post",
      getRequestUrl("/api/MemberViolation/findMemberViolationByPage"),
      data,
      {
        method
      }
    ).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 充值风险管理 -- 列表
  riskControlList(data, method) {
    return ajax(
      "post",
      getRequestUrl("/risk/rechargeRisk/account/list"),
      data,
      {
        method
      }
    );
  },

  // 充值风险管理 -- 添加
  riskControlAdd(data, method) {
    return ajax(
      "post",
      getRequestUrl("/risk/rechargeRisk/account/add"),
      data,
      {
        method
      }
    );
  },

  // 充值风险管理 -- 编辑
  riskControlEdit(data, method) {
    return ajax(
      "post",
      getRequestUrl("/risk/rechargeRisk/account/edit"),
      data,
      {
        method
      }
    );
  },

  // 充值风险管理 -- 移出
  riskControlDelete(data, method) {
    return ajax(
      "post",
      getRequestUrl("/risk/rechargeRisk/account/batchDelete"),
      data,
      {
        method
      }
    );
  },

  // 充值风险管理 -- 拦截日志
  riskControlRecordList(data, method) {
    return ajax(
      "post",
      getRequestUrl("/risk/rechargeRisk/intercept/list"),
      data,
      {
        method
      }
    );
  },

  // 充值风险管理 -- 设备与IP列表
  riskControlDeviceAndIpList(data, method) {
    return ajax(
      "post",
      getRequestUrl("/risk/rechargeRisk/deviceAndIp/list"),
      data,
      {
        method
      }
    );
  },

  // 充值风险管理 -- 批量启动或暂停风控IP/设备
  riskControlDeviceAndIpbatchOpt(data, method) {
    return ajax(
      "post",
      getRequestUrl("/risk/rechargeRisk/deviceAndIp/batchOpt"),
      data,
      {
        method
      }
    );
  },

  // 充值风险管理 -- 编辑风险IP/设备
  riskControlDeviceAndIpEdit(data, method) {
    return ajax(
      "post",
      getRequestUrl("/risk/rechargeRisk/deviceAndIp/edit"),
      data,
      {
        method
      }
    );
  },

  // 风控管理 -- 退款处理中心 -- 退款明细
  refundDetailsList(data, method) {
    return ajax(
      "post",
      getRequestUrl("/risk/refundCenter/refund/list"),
      data,
      {
        method
      }
    );
  },

  // 风控管理 -- 冻结账号明细 v2
  freezeMemberListV2(data, method) {
    return ajax(
      "post",
      getRequestUrl("/ban/freezeMember/list/v2"),
      data,
      {
        method
      }
    );
  },

  // 风控管理 -- 退款单数、金额接口
  allRechargeToken(data) {
    return ajax(
      "post",
      getRequestUrl("/api/Member/allRechargeToken"),
      data,
    );
  },

  // 风控管理 -- 还款处理
  repayment(data) {
    return ajax(
      "post",
      getRequestUrl("/risk/refundCenter/repay"),
      data,
    );
  },

  // 风控管理 -- 还款明细接口
  repaymentList(data) {
    return ajax(
      "post",
      getRequestUrl("/risk/refundCenter/repay/list"),
      data,
    );
  },

  // 风控管理 -- 退款警告
  refundCenterNotify(data) {
    return ajax(
      "post",
      getRequestUrl("/risk/refundCenter/notify"),
      data,
    );
  },

  // 风控管理 -- 批量冻结消费/解冻消费
  refundCenterBatchFreezeMember(data) {
    return ajax(
      "post",
      getRequestUrl("/ban/batchFreezeMember"),
      data,
    );
  },

  // 风控管理 -- 批量封禁ID
  batchBanId(data) {
    return ajax(
      "post",
      getRequestUrl("/ban/batchBan"),
      data,
    );
  },

  // 风控管理 -- 冻结明细接口
  frozenAccountList(data) {
    return ajax(
      "post",
      getRequestUrl("/api/Member/frozenAccountList"),
      data,
    );
  },

  // 风控管理 -- 选择封禁ID
  selectBlockId(data) {
    return ajax(
      "post",
      getRequestUrl("/api/Member/selectBlockId"),
      data,
    );
  },

  // 风控管理 -- KA管理列表
  memberKaList(data) {
    return ajax(
      "post",
      getRequestUrl("/api/Member/memberKaList"),
      data,
    );
  },

  // 风控管理 -- 批量添加ka用户操作
  memberKaBatch(data) {
    return ajax(
      "post",
      getRequestUrl("/api/Member/memberKaBatch"),
      data,
    );
  },

  // 风控管理 -- 移除KA列表
  memberKaDelete(data) {
    return ajax(
      "post",
      getRequestUrl("/api/Member/memberKaDelete"),
      data,
    );
  },

  // 用户管理 -- svip操作记录
  BannedSvipList(data) {
    return ajax(
      "post",
      getRequestUrl("/user/svip/logs"),
      data,
    );
  },

  // 用户管理 -- 游戏段位详情
  gameRankDetails(data) {
    return ajax(
      "post",
      getRequestUrl("/api/Member/gameRankDetails"),
      data,
    );
  },

  // 用户管理 -- 解除svip封禁
  unBannedSvip(data) {
    return ajax(
      "post",
      getRequestUrl("/ban/unfreezeSvip"),
      data,
    );
  },

  // 用户管理 -- 封禁用户svip
  bannedSvip(data) {
    return ajax(
      "post",
      getRequestUrl("/ban/freezeSvip"),
      data,
    );
  },

  // QA问题 -- 热门QA管理列表
  questionList(data) {
    return ajax(
      "post",
      getRequestUrl("/api/Question/questionList"),
      data,
    );
  },

  // QA问题 -- 热门QA管理添加
  questionAdd(data) {
    return ajax(
      "post",
      getRequestUrl("/api/Question/questionAdd"),
      data,
    );
  },

  // QA问题 -- 热门QA管理删除
  questionDel(data) {
    return ajax(
      "post",
      getRequestUrl("/api/Question/questionDel"),
      data,
    );
  },

  // 用户举报列表
  getUReportList(data, method) {
    return ajax('post', getRequestUrl('/api/Report/findMemberReportByPage'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 用户举报--忽略举报
  ignoreReportBatch(data, method) {
    return ajax('post', getRequestUrl('/api/Report/ignoreReportBatch'), data, {
      method,
    });
  },

  // 用户举报--删除举报
  userDeleteReport(data, method) {
    return ajax('post', getRequestUrl('/api/Report/deleteReport'), data, {
      method,
    })
  },

  // 用户举报--发送警告信
  noticeUser(data, method) {
    return ajax('post', getRequestUrl('/user/recharge/refundWarn'), data, {
      method,
    });
  },

  // 用户举报--批量选择封禁设备
  bannedDeviceBatch(data, method) {
    return ajax('post', getRequestUrl('/api/Report/bannedDeviceBatch'), data, {
      method,
    });
  },

  // 用户举报--批量重置资料
  resetUserInfoBatch(data, method) {
    return ajax('post', getRequestUrl('/api/Report/resetUserInfoBatch'), data, {
      method,
    });
  },

  // 用户举报--批量选择封禁id
  bannedIdBatch(data, method) {
    return ajax('post', getRequestUrl('/api/Report/bannedIdBatch'), data, {
      method,
    });
  },

  // 用户举报--删除照片
  resetPhoto(data, method) {
    return ajax('post', getRequestUrl('/api/Report/resetPhoto'), data, {
      method,
    });
  },

  checkOperateUser(data, method) {
    return ajax('post', getRequestUrl('/api/CommonHelper/checkOperateUser'), data, {
      method,
    });
  },

  getClientLogFile(data, method){
    return ajax('post', getRequestUrl('/upload/getClientLogFile'), data, {
      method,
    });
  },

  ...invite,
  ...users,
  ...roomColumn,
  ...jHttp,
  ...roomCrystal,
  ...room,
  ...Activity,
  ...setting,
  ...admin,
  ...message,
  ...sengCoins,
  ...agent,
  ...power,
  ...role,
  ...ad,
  ...family,
  ...shop,
  ...gift,
  ...group,
  ...approval,
  ...data,
  ...bd,
  ...activityDeploy,
  ...templateAct,
  ...countryAdmin,
  ...communityApi,
  ...musicLibs,
  ...tribeManagement,
  ...roomBot,
};



// WEBPACK FOOTER //
// ./src/js/http.js